import { AAMUPALA } from '../config/aamupala';
import { KLAPI } from '../config/gameplay';
import { TASK_FEEDBACK } from '../config/hud';
import { clamp } from '../utils/math';

export interface ObjectiveProgress {
  now: number;
  atPalju: boolean;
  logs: number;
  atBreakfast: boolean;
  servings: number;
  inLanRoom: boolean;
  poured: boolean;
}

export interface ObjectiveView {
  text: string;
  counter: string | null;
  complete: boolean;
  check: number;
  opacity: number;
}

/** Presentation state only: keep an errand visible after walking away from it. */
export class RunObjective {
  private stage = 0;
  private completedAt: number | null = null;

  reset(): void {
    this.stage = 0;
    this.completedAt = null;
  }

  update(progress: ObjectiveProgress): ObjectiveView | null {
    const next = progress.inLanRoom ? 3 : progress.atBreakfast ? 2 : progress.atPalju ? 1 : 0;
    if (next > this.stage) {
      this.stage = next;
      this.completedAt = null;
    }
    const text = [
      'Siirry omalle paikallesi',
      'Laita kaksi klapia pesään',
      'Valitse kolme liharuokaa',
      'Ota tuoppi ja täytä se simalla.',
    ][this.stage];
    const count = this.stage === 1 ? progress.logs : progress.servings;
    const total = this.stage === 1 ? KLAPI.logsNeeded : AAMUPALA.servings;
    const counted = this.stage === 1 || this.stage === 2;
    const complete = counted ? count >= total : this.stage === 3 && progress.poured;
    if (complete && this.completedAt === null) this.completedAt = progress.now;
    const age = this.completedAt === null ? 0 : Math.max(0, progress.now - this.completedAt);
    const opacity = 1 - clamp((age - TASK_FEEDBACK.holdSeconds) / TASK_FEEDBACK.fadeSeconds, 0, 1);
    if (opacity === 0) {
      return this.stage === 3
        ? { text: 'Siirry omalle paikallesi', counter: null, complete: false, check: 0, opacity: 1 }
        : null;
    }
    return {
      text,
      counter: counted ? `${Math.min(count, total)}/${total}` : null,
      complete,
      check: complete ? clamp(age / TASK_FEEDBACK.checkSeconds, 0, 1) : 0,
      opacity,
    };
  }
}
